import { AdminGridWrapper } from '../styles';
import { ISwapQualityIssueForList } from '@nkr/models/index';
import { SwapQualityIssueListType, SwapQualityIssueReportedBy } from '@nkr/enums/index';
import CommonList from './common-list';

interface IProps {
    centerId: number,
    data: ISwapQualityIssueForList[],
    listType: SwapQualityIssueListType,
    reportedBy: SwapQualityIssueReportedBy,
    onConfirmReopen: (id: number) => void
}

const AdminMicrositeList = (props: IProps) => {
    return (
        <AdminGridWrapper className='ag-theme-bootstrap'>
            <CommonList
                data={props.data}
                centerId={props.centerId}
                listType={props.listType}
                reportedBy={props.reportedBy}
                isAdmin={true}
                isAdminLogin={true}
                onConfirmReopen={props.onConfirmReopen}
            />
        </AdminGridWrapper>
    );
}

export default AdminMicrositeList;